import script from "./SetupDomainModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupDomainModal.vue?vue&type=script&setup=true&lang=js"

import "./SetupDomainModal.vue?vue&type=style&index=0&id=b9b93280&lang=css"

const __exports__ = script;

export default __exports__